<template>
  <div
    class="u-position-relative u-text-align-center u-display-flex u-align-items-center u-justify-content-center"
    :style="`width: ${creatingPdf ? '550px' : '550px'}; margin: 0 auto`"
  >
    <div
      class="u-background-color-light-muted u-radius-g"
      style="position: absolute; top: -2%; left: 20%; width: 100px"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cycleDetail.coolPropSubcool2") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{
            (cycle.coolPropSuperheat - cycle.evaporatorTemperature).toFixed(2)
          }}
          °C
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      style="position: absolute; top: -2%; right: 20%; width: 100px"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cycleDetail.coolPropSuperheat2") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{
            (cycle.coolPropDischargeTemp - cycle.condenserTemperature).toFixed(
              2
            )
          }}
          °C
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      :style="`position: absolute; top: -1.8%; left: ${
        !creatingPdf ? '-5%' : '-5%'
      }; width: 80px`"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cycleDetail.coolPropSuperheat") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.coolPropSuperheat.toFixed(2) }} °C
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      :style="`position: absolute; top: -1.8%; right: ${
        !creatingPdf ? '-5%' : '-5%'
      }; width: 80px`"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cycleDetail.coolPropDischargeTemp") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.coolPropDischargeTemp.toFixed(2) }} °C
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      style="position: absolute; top: 17.5%; right: calc(22.5%); width: 80px"
    >
      <small class="u-font-size-xsmall"> 2 </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.coolPropH2CompOutCondIn.toFixed(2) }} kJ/kg
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      style="position: absolute; bottom: 22.5%; right: calc(22.5%); width: 80px"
    >
      <small class="u-font-size-xsmall"> 3 </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.coolPropH3CondOutExpIn.toFixed(2) }} kJ/kg
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      style="position: absolute; bottom: 22.5%; left: calc(20%); width: 80px"
    >
      <small class="u-font-size-xsmall"> 4 </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.coolPropH4ExpOutEvapIn.toFixed(2) }} kJ/kg
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      style="position: absolute; top: 17.5%; left: calc(20%); width: 80px"
    >
      <small class="u-font-size-xsmall"> 1 </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.coolPropH1EvapOutCompIn.toFixed(2) }} kJ/kg
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      :style="`position: absolute; bottom: ${
        !creatingPdf ? '0' : '0'
      }; left: 20%; width: 100px`"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cycleDetail.coolPropX4") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.coolPropX4.toFixed(2) }} x4
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      :style="`position: absolute; bottom: ${
        !creatingPdf ? '0' : '0'
      }; right: 20%; width: 100px`"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cycleDetail.coolPropSubcool") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.coolPropSubcool.toFixed(2) }} °C
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      :style="`position: absolute; top: calc(25%); left: ${
        !creatingPdf ? '-5%' : '-5%'
      }; width: 90px`"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cyclesForm.evaporatorCapacity") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.evaporatorTemperature.toFixed(2) }} °C
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      :style="`position: absolute; top: calc(60%); left: ${
        !creatingPdf ? '-5%' : '-5%'
      }; width: 90px`"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cycleDetail.evaporatorBar") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.lp.toFixed(2) }} BAR
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      :style="`position: absolute; top: calc(25%); right: ${
        !creatingPdf ? '-5%' : '-5%'
      }; width: 90px`"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cyclesForm.condensingTemp") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.condenserTemperature.toFixed(2) }} °C
        </strong>
      </div>
    </div>
    <div
      class="u-background-color-light-muted u-radius-g"
      :style="`position: absolute; top: calc(60%); right: ${
        !creatingPdf ? '-5%' : '-5%'
      }; width: 90px`"
    >
      <small class="u-font-size-xsmall">
        {{ $t("cycleDetail.condensingBar") }}
      </small>
      <div>
        <strong class="u-color-primary u-font-size-xsmall">
          {{ cycle.hp.toFixed(2) }} BAR
        </strong>
      </div>
    </div>
    <img
      src="@/assets/images/cooling-cycle.png"
      style="width: 100%"
      alt="result"
    />
  </div>
</template>

<script>
export default {
  props: {
    cycle: {
      type: Object,
      required: true,
    },
    creatingPdf: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style></style>
